import { type AppContextData } from "./common/AppContext";

export const getCurrentApplication = (
  arenaDomain: string | undefined,
): AppContextData["application"] => {
  if (arenaDomain) {
    return "singleManagerPortal";
  }

  return "multiManagerPortal";
};

export const formatUnitCount = (
  unitCount: number,
  precision: number,
  showNegative = false,
): string => {
  const result = unitCount.toLocaleString("en", { minimumFractionDigits: precision });
  if (result.startsWith("-") && !showNegative) {
    return `(${result.substring(1)})`;
  }
  return result;
};

export const removeTrailingSlash = (path: string): string => {
  return path.replace(/\/$/, "");
};
